import { ID } from "../definitions/types";
import { ElementDefinitionTarget } from "../models/integration.model";

export interface IntegrationDetail {
    id: ID;
    name: string;
    type: ElementDefinitionTarget;
    connectionString: string;
}


export const WORKROADS_INTEGRATION: IntegrationDetail = {
    name: "",
    type: ElementDefinitionTarget.Workroads,
    id: 0,
    connectionString: '',
}